export default __webpack_public_path__ + "static/Flag_of_Uganda.svg-1a3f8dba229c3169a0837a9454d6854f.png";